import { Context } from '../..';
import * as base from '../base';
import { TeamMemberReviewResource } from '../../../models/team-member-review-resource';
import { handleErrorToErrorPage } from '../functions';
import { ErrorSignalTypes } from '../../../enums';
import { LearnerSelfReviews } from '../../../models/learner-skill-resource';

// @Jedidja
export async function getTeamReviews(context: Context): Promise<TeamMemberReviewResource[] | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `get-team-reviews`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true };
  const response: base.IResponse<TeamMemberReviewResource[]> = await base.request(request);

  return response.data;
}

// @Jedidja
export async function submitTeamReviews(context: Context): Promise<void> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `complete-team-reviews`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true, method: 'POST' };
  await base.request(request);
}

// @Jedidja
export async function submitTeamMemberReview(context: Context, payload: TeamMemberReviewResource): Promise<TeamMemberReviewResource | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `submit-team-member-review`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true, method: 'POST', body: JSON.stringify([payload]) };
  const response: base.IResponse<TeamMemberReviewResource> = await base.request(request);

  return response.data;
}

// @Jedidja
export async function completeSelfReview(context: Context): Promise<void> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `complete-self-review`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true, method: 'POST' };
  await base.request(request);
}

// @Jedidja
export async function getSelfReviews(context: Context): Promise<LearnerSelfReviews | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `get-self-reviews`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true };
  const response: base.IResponse<LearnerSelfReviews> = await base.request(request);

  return response.data;
}

// @Jedidja
export async function submitSelfReviews(context: Context, payload: LearnerSelfReviews): Promise<void> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(`review`, `submit-self-reviews`, context.state.activeAssessmentConfig?.assessmentSlug), authenticated: true, method: 'POST', body: JSON.stringify(payload) };
  await base.request(request);
}